import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Fab, Typography, Tooltip } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  container: {
    padding: '10px',
    borderRadius: '4px',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
  },
  containerArray: {
    display: 'flex',
    marginBottom: '12px',
    alignItems: 'self-start',
    textAlign: 'center',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    '& label': {
      color: '#8F9BBC',
      marginBottom: '1rem'
    }
  },
  containerChildren: {
    width: '100%',
    padding: '10px'
  },
  containerChildrenArray: {
    width: '100%',
    padding: '10px',
    textAlign: 'left'
  },
  addBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button ': {
      marginRight: '1rem'
    }
  },
  deleteIcon: {
    padding: '6px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 0
  }
}));

const DefaultArrayItem = ({ element }) => {
  const classes = useStyles();
  return (
    <div className={classes.containerArray}>
      <div className={element.className === 'array-item' ? classes.containerChildrenArray : classes.containerChildren}>
        {element.children}
      </div>
      {element.hasToolbar && (
        <IconButton className={classes.deleteIcon} onClick={element.onDropIndexClick(element.index)}>
          <HighlightOffIcon fontSize='default' color='secondary' />
        </IconButton>
      )}
    </div>
  );
};

const ArrayTemplate = (props) => {
  const { t } = useTranslation();
  const { title, schema: { title: schemaTtitle }, items, canAdd, onAddClick } = props;
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {title && <Typography style={{ fontSize: '20px' }} gutterBottom>{title}</Typography>}
      {items.map((element, i) => (
        <DefaultArrayItem
          element={element}
          title={schemaTtitle}
          key={i}
        />
      ))
      }
      {canAdd && (
        <div className={classes.addBtn}>
          <Tooltip title={t('viewer:add')}>
            <Fab aria-label='Add' color='primary' size='small' onClick={onAddClick} >
              <AddOutlined />
            </Fab>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

DefaultArrayItem.propTypes = {
  classes: PropTypes.object,
  element: PropTypes.object,
  title: PropTypes.string
};

ArrayTemplate.propTypes = {
  schema: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  canAdd: PropTypes.bool.isRequired,
  onAddClick: PropTypes.func.isRequired,
  title: PropTypes.string
};

export default ArrayTemplate;
